import axiosInstance from "../utils/axios";

export const fileService = {
  getFile: async (uuid) => {
    const response = await axiosInstance.get(`/file/show/${uuid}`, {
      responseType: "blob",
    });
    return response.data;
  },
};
